import { Notify, Loading, Dialog } from "quasar"

import DOMPurify from "dompurify"

import i18n from "@/plugins/i18n.js"

export const showToast = ({ message }) =>
  Notify.create({
    message,
    timeout: 3000,
    color: "positive"
  })

export const showErrorToast = ({ message, timeout, err }) => {
  Notify.create({
    message: message || i18n.global.t("_RSFAP_SHARED_SERVER_ERROR"),
    color: "negative",
    timeout: timeout ?? 5000
  })

  if (err) {
    handleError(err)
  }
}

export const handleError = (err, asWarning) => {
  if (asWarning) {
    //eslint-disable-next-line no-console
    console.warn(err)
  } else {
    console.error(err)
  }
}

export const showLoading = () => Loading.show({ delay: 100 })

export const hideLoading = () => Loading.hide()

export const showDialog = ({ cancel, ...options }) =>
  Dialog.create({
    ...options,
    message: options.html ? DOMPurify.sanitize(options.message) : options.message,
    persistent: true,
    cancel: cancel === true ? { outline: true } : cancel ? { ...cancel, outline: true } : null,
    ok: {
      color: "primary"
    }
  })
